import React, { createContext, useContext, useState, useMemo, useEffect } from 'react';
import '../styles/global/admin-theme.css';
import '../styles/layout/admin-shell.css';
import '../styles/layout/data-table.css';

const THEME_MODE_KEY = 'admin_theme_mode';

const AdminThemeContext = createContext({
  mode: 'light',
  toggleColorMode: () => {},
});

export const useAdminTheme = () => {
  const context = useContext(AdminThemeContext);
  if (!context) {
    throw new Error('useAdminTheme must be used within an AdminThemeProvider');
  }
  return context;
};

export const AdminThemeProvider = ({ children }) => {
  const [mode, setMode] = useState(() => {
    const savedMode = localStorage.getItem(THEME_MODE_KEY);
    return savedMode || 'light';
  });

  useEffect(() => {
    localStorage.setItem(THEME_MODE_KEY, mode);
    try {
      if (typeof document !== 'undefined') {
        document.body.setAttribute('data-theme', mode);
      }
    } catch {}
  }, [mode]);

  const colorMode = useMemo(
    () => ({
      mode,
      toggleColorMode: () => {
        setMode((prevMode) => (prevMode === 'light' ? 'dark' : 'light'));
      },
    }),
    [mode]
  );

  return (
    <AdminThemeContext.Provider value={colorMode}>
      <div className="admin-app">{children}</div>
    </AdminThemeContext.Provider>
  );
};
